import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationService } from 'src/app/service/navigation.service';
import { QuoteService } from 'src/app/service/quote.service';

@Component({
  selector: 'app-quote-step12-desktop',
  templateUrl: './quote-step12-desktop.component.html',
  styleUrls: ['./quote-step12-desktop.component.css']
})
export class QuoteStep12DesktopComponent implements OnInit {
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/0ffa27a0-cde7-40b2-b686-1c5fe568d7e8?org_if_sml=1743&force_format=original'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/0c50e848-44cb-4b7a-a43b-7845858dfd22?org_if_sml=1744&force_format=original'
  @Input()
  vectoralt4: string = 'VectorI3390'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f26ba2d0-4228-4104-b97d-26e0b64b668b?org_if_sml=1222&force_format=original'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/9bf8c5b5-a0a4-478a-95ec-4a908208265f?org_if_sml=1740&force_format=original'
  @Input()
  vectorsrc2: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/ff27dda0-1632-42ac-a293-ff7dce3f865e?org_if_sml=1171&force_format=original'
  @Input()
  vectoralt3: string = 'VectorI3390'
  @Input()
  vectoralt1: string = 'VectorI3390'
  @Input()
  vectoralt10: string = 'VectorI3390'
  @Input()
  vectorsrc1: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/bcbc2ead-66cc-4a47-a6d2-eeb21fa63444?org_if_sml=1624&force_format=original'
  @Input()
  rectangle1269alt: string = 'Rectangle12693390'
  @Input()
  gradient21src: string = '/assets/external/gradient213390-j4tc-300w.png'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/2d413ad1-0abf-46a7-a554-8c374a0cb129?org_if_sml=1490&force_format=original'
  @Input()
  gradient21alt: string = 'gradient213390'
  @Input()
  vectorsrc: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/1900f11d-6263-46d6-a2b0-34839e7f6dff?org_if_sml=11328&force_format=original'
  @Input()
  vectoralt6: string = 'VectorI3390'
  @Input()
  vectoralt: string = 'VectorI3390'
  @Input()
  rootClassName: string = ''
  @Input()
  rectangle1269src: string = '/assets/external/rectangle12693390-d9n-2000w.png'
  @Input()
  vectoralt8: string = 'VectorI3390'
  @Input()
  vectorsrc4: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/dbb52b8e-9845-43fb-b175-ea9463a41b1d?org_if_sml=1633&force_format=original'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/24be63e2-58fe-443b-8e86-b430b7f129cd?org_if_sml=1517&force_format=original'
  @Input()
  vectorsrc3: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/4cba59ae-4440-4492-9e73-f5310468b99c?org_if_sml=1503&force_format=original'
  @Input()
  vectoralt9: string = 'VectorI3390'
  @Input()
  vectoralt5: string = 'VectorI3390'
  @Input()
  vectoralt2: string = 'VectorI3390'
  @Input()
  vectoralt7: string = 'VectorI3390'
  raw8w4c: string = ' '

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  
  constructor(private navigate: NavigationService, private quoteService: QuoteService) {}

  nextStep(): void {
		 this.onNextStep.emit(this.currentStep);
	}

  prevStep(): void {
    this.quoteService.updateQuote$(this.quoteService.quoteModel).subscribe(r => {
      
    })
    this.onPrevStep.emit(this.currentStep);
 }

  goSegurados()
  {
    this.navigate.navigateToInsured()
  }

  ngOnInit() {
  }

}
